(() => {
  const setupShippingPolicy = () => {
    const policyBody = document.querySelector('.gio-shipping-policy-page .shopify-policy__body .rte');
    const table = policyBody?.querySelector('table');
    if (!policyBody || !table || table.dataset.shippingSearch === 'true') return;

    table.dataset.shippingSearch = 'true';

    const headings = table.querySelectorAll('thead th');
    const labels = ['Land', 'Zone', 'Lieferzeit', 'Kosten'];
    headings.forEach((heading, index) => {
      if (labels[index]) heading.textContent = labels[index];
    });

    const tbody = table.querySelector('tbody');
    if (!tbody) return;

    const rows = Array.from(tbody.querySelectorAll('tr'));
    rows.forEach((row) => {
      const countryCell = row.cells[0];
      if (countryCell && /^GROSSBRITANNIE(?:N)?$/i.test(countryCell.textContent.trim())) {
        countryCell.textContent = 'VEREINIGTES KÖNIGREICH';
      }
    });
    const priorityCountries = [
      'DEUTSCHLAND',
      'ÖSTERREICH',
      'NIEDERLANDE',
      'BELGIEN',
      'FRANKREICH',
      'LUXEMBURG',
      'DÄNEMARK',
      'VEREINIGTES KÖNIGREICH',
      'SCHWEIZ',
      'USA',
    ];

    const normalize = (value) => value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLocaleLowerCase('de-DE')
      .trim();

    const countryName = (row) => row.cells[0]?.textContent.trim() || '';
    const searchableName = (row) => normalize(countryName(row));

    const tools = document.createElement('div');
    tools.className = 'gio-shipping-tools';

    const searchIcon = document.createElement('span');
    searchIcon.className = 'gio-shipping-search-icon';
    searchIcon.setAttribute('aria-hidden', 'true');

    const input = document.createElement('input');
    input.className = 'gio-shipping-search';
    input.type = 'search';
    input.autocomplete = 'off';
    input.placeholder = 'Wohin soll deine Bestellung gehen?';
    input.setAttribute('aria-label', 'Versandland suchen');

    const clearButton = document.createElement('button');
    clearButton.className = 'gio-shipping-clear';
    clearButton.type = 'button';
    clearButton.setAttribute('aria-label', 'Suche löschen');
    clearButton.textContent = '×';

    tools.append(searchIcon, input, clearButton);

    const tableWrap = document.createElement('div');
    tableWrap.className = 'gio-shipping-table-wrap';
    table.parentNode.insertBefore(tools, table);
    table.parentNode.insertBefore(tableWrap, table);
    tableWrap.appendChild(table);

    const hint = document.createElement('p');
    hint.className = 'gio-shipping-hint';
    tableWrap.insertAdjacentElement('afterend', hint);

    const emptyRow = document.createElement('tr');
    emptyRow.className = 'gio-shipping-empty';
    const emptyCell = document.createElement('td');
    emptyCell.colSpan = 4;
    emptyCell.textContent = 'Kein Land gefunden';
    emptyRow.appendChild(emptyCell);

    const renderRows = () => {
      const query = normalize(input.value);
      let visibleRows;

      if (query) {
        visibleRows = rows.filter((row) => searchableName(row).includes(query));
      } else {
        visibleRows = rows
          .filter((row) => priorityCountries.includes(countryName(row).toLocaleUpperCase('de-DE')))
          .sort((rowA, rowB) => {
            const zoneA = Number.parseFloat((rowA.cells[1]?.textContent || '99').replace(',', '.'));
            const zoneB = Number.parseFloat((rowB.cells[1]?.textContent || '99').replace(',', '.'));
            return zoneA - zoneB || priorityCountries.indexOf(countryName(rowA).toLocaleUpperCase('de-DE')) - priorityCountries.indexOf(countryName(rowB).toLocaleUpperCase('de-DE'));
          });
      }

      tbody.replaceChildren(...(visibleRows.length ? visibleRows : [emptyRow]));
      clearButton.classList.toggle('is-visible', query.length > 0);
      hint.textContent = query
        ? `${visibleRows.length} ${visibleRows.length === 1 ? 'Ergebnis' : 'Ergebnisse'}`
        : `Versand in ${rows.length} Länder weltweit - gib oben dein Zielland ein`;
    };

    input.addEventListener('input', renderRows);
    clearButton.addEventListener('click', () => {
      input.value = '';
      input.focus();
      renderRows();
    });

    renderRows();
  };

  const initializeShippingPage = () => {
    setupShippingPolicy();
    document.documentElement.classList.remove('gio-shipping-loading');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeShippingPage, { once: true });
  } else {
    initializeShippingPage();
  }
})();
